import { Component } from '@theme/component';

/**
 * A custom element that formats rte content for easier styling
 */
class RTEFormatter extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.querySelectorAll('table').forEach(this.#formatTable);
    if (this.hasAttribute('data-unheadify-h2')) {
      this.querySelectorAll('h2').forEach(this.#unheadify);
    }
  }

  /**
   * Replaces a heading with a non-heading element that keeps the same
   * visual style (via the theme's .h2 utility class) without being
   * announced/indexed as a real heading.
   * @param {HTMLHeadingElement} heading
   */
  #unheadify(heading) {
    const replacement = document.createElement('p');
    replacement.classList.add('h2');
    for (const attr of heading.attributes) {
      if (attr.name === 'class') continue;
      replacement.setAttribute(attr.name, attr.value);
    }
    replacement.innerHTML = heading.innerHTML;
    heading.replaceWith(replacement);
  }

  /**
   * Formats a table for easier styling
   * @param {HTMLTableElement} table
   */
  #formatTable(table) {
    const wrapper = document.createElement('div');
    wrapper.classList.add('rte-table-wrapper');
    const parent = table.parentNode;
    if (parent) {
      parent.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    }
  }
}

if (!customElements.get('rte-formatter')) {
  customElements.define('rte-formatter', RTEFormatter);
}
